import i18n from '@/lang/i18n'
import { StatisticalAnalysisOperation } from '@/api/operations/models/statistical-analysis-operation'
import sessionStore from '@/session/sessionStore'

export interface StatisticalAnalysisHomeCategories {
    name: string
    color: string
}
export interface StatisticalAnalysisHomeState {
    title: string
    img: string
    columns: string
    description: string
    link: string
    id: string
    categories: StatisticalAnalysisHomeCategories[]
    active: boolean
}
export const initialStatisticalAnalysisHomeState =
    (): StatisticalAnalysisHomeState[] => [
        {
            title: i18n.tc('statisticalAnalysis.sections.generalStatistics'),
            img: require('@/img/general-statistics.jpg'),
            columns: 'col-lg-4 col-md-4 col-sm-6',
            description: i18n.tc('statisticalAnalysis.sections.generalStatisticsDescription'),
            link: 'GeneralStatistics',
            id: 'general-statistics',
            categories: [
                { name: i18n.tc('statisticalAnalysis.categories.tracking'), color: 'tomato' },
                { name: i18n.tc('statisticalAnalysis.categories.details'), color: 'spring-green' },
                { name: i18n.tc('statisticalAnalysis.categories.grids'), color: 'dark-turquoise' },
                { name: i18n.tc('statisticalAnalysis.categories.charts'), color: 'blue-violet' }
            ],
            active: sessionStore.hasLabOperationOnSelectedLaboratory(StatisticalAnalysisOperation.GENERAL_STATISTIC)
        },
        {
            title: i18n.tc('statisticalAnalysis.sections.serviceActivity'),
            img: require('@/img/service-activity.jpg'),
            columns: 'col-lg-4 col-md-4 col-sm-6',
            description: i18n.tc('statisticalAnalysis.sections.serviceActivityDescription'),
            link: 'ServiceActivity',
            id: 'service-activity',
            categories: [
                { name: i18n.tc('statisticalAnalysis.categories.indicators'), color: 'light-salmon' },
                { name: i18n.tc('statisticalAnalysis.categories.grids'), color: 'dark-turquoise' },
                { name: i18n.tc('statisticalAnalysis.categories.charts'), color: 'blue-violet' }
            ],
            active: sessionStore.hasLabOperationOnSelectedLaboratory(StatisticalAnalysisOperation.ACTIVITY)
        },
        {
            title: i18n.tc('statisticalAnalysis.sections.incidents'),
            img: require('@/img/incidents.jpg'),
            columns: 'col-lg-4 col-md-4 col-sm-6',
            description: i18n.tc('statisticalAnalysis.sections.incidentsDescription'),
            link: 'IncidentStatistics',
            id: 'incidents',
            categories: [
                { name: i18n.tc('statisticalAnalysis.categories.indicators'), color: 'light-salmon' },
                { name: i18n.tc('statisticalAnalysis.categories.widgets'), color: 'dark-orange' },
                { name: i18n.tc('statisticalAnalysis.categories.grids'), color: 'dark-turquoise' },
                { name: i18n.tc('statisticalAnalysis.categories.charts'), color: 'blue-violet' }
            ],
            active: sessionStore.hasLabOperationOnSelectedLaboratory(StatisticalAnalysisOperation.INCIDENT)
        },
        {
            title: i18n.tc('statisticalAnalysis.sections.delaysAndResponseTimes'),
            img: require('@/img/delays-and-response-times.jpg'),
            columns: 'col-lg-4 col-md-4 col-sm-6',
            description: i18n.tc('statisticalAnalysis.sections.delaysAndResponseTimesDescription'),
            link: 'DelaysAndResponseTime',
            id: 'delays-and-response-time',
            categories: [
                { name: i18n.tc('statisticalAnalysis.categories.indicators'), color: 'light-salmon' },
                { name: i18n.tc('statisticalAnalysis.categories.details'), color: 'spring-green' },
                { name: i18n.tc('statisticalAnalysis.categories.grids'), color: 'dark-turquoise' },
                { name: i18n.tc('statisticalAnalysis.categories.charts'), color: 'blue-violet' }
            ],
            active: sessionStore.hasLabOperationOnSelectedLaboratory(StatisticalAnalysisOperation.DELAY_AND_RESPONSE_TIME)
        },
        {
            title: i18n.tc('statisticalAnalysis.sections.labeledSamples'),
            img: require('@/img/labeled-samples.jpg'),
            columns: 'col-lg-4 col-md-4 col-sm-6',
            description: i18n.tc('statisticalAnalysis.sections.labeledSamplesDescription'),
            link: 'LabeledSamples',
            id: 'labeled-samples',
            categories: [
                { name: i18n.tc('statisticalAnalysis.categories.indicators'), color: 'light-salmon' },
                { name: i18n.tc('statisticalAnalysis.categories.grids'), color: 'dark-turquoise' },
                { name: i18n.tc('statisticalAnalysis.categories.charts'), color: 'blue-violet' }
            ],
            active: sessionStore.hasLabOperationOnSelectedLaboratory(StatisticalAnalysisOperation.SAMPLE_TAGS)
        },
        {
            title: i18n.tc('statisticalAnalysis.sections.billing'),
            img: require('@/img/billing.jpg'),
            columns: 'col-lg-4 col-md-4 col-sm-6',
            description: i18n.tc('statisticalAnalysis.sections.billingDescription'),
            link: 'Billing',
            id: 'billing',
            categories: [
                { name: i18n.tc('statisticalAnalysis.categories.tracking'), color: 'tomato' },
                { name: i18n.tc('statisticalAnalysis.categories.details'), color: 'spring-green' },
                { name: i18n.tc('statisticalAnalysis.categories.grids'), color: 'dark-turquoise' },
                { name: i18n.tc('statisticalAnalysis.categories.charts'), color: 'blue-violet' }
            ],
            // TODO: Remove comment when developed
            // active: sessionStore.hasLabOperationOnSelectedLaboratory(StatisticalAnalysisOperation.BILLING)
            active: false
        }
    ]
